import {
  AsyncPropSelector,
  ApiProgressLoader,
  BackgroundIcon,
  Generator,
  useProduct
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState, useContext } from 'react';
import styled from 'styled-components';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { isDependantField } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { AccountClient, GET_CLIENT_USERS_LIST } from '@nile/graphql';
import gql from 'graphql-tag';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_CLIENT_USERS } from '@nile/graphql/src/Query/client';
import { SVGIcon } from '@superops/super-icons';
import {
  getTechnicianVariables,
  getClientUserAssociationListVariables
} from '@nile/graphql/src/Constants/variablesResolver';

const Wrap = styled.div`
  max-width: 100%;
  min-height: 38px;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

const WrapperTag = styled.div.attrs({
  className: 'full-height'
})``;

const StyledTag = styled.div`
  background: #e3edff;
  padding: 2px 10px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 500;
`;

const Value = styled.div`
  line-height: 16px;
  font-weight: bold;
  color: ${(props) => (props.link ? 'blue' : 'inherit')};
  white-space: nowrap;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: ${(props) => (props.link ? 'pointer' : 'default')};
`;

function InlineDependantSelect(props) {
  const {
    cell,
    params,
    _ticket,
    mode = 'view',
    updateFieldState,
    type,
    isClearable
  } = props;
  const allProps = params || cell.column;
  const {
    editable,
    field,
    actions,
    accessor,
    entity,
    autoSave,
    parentField,
    dependantField,
    shouldFreezeCell
  } = allProps;
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  const isEditable = !isCellFreezed && editable;
  const ticketContext = useContext(TicketContext);
  const ticket = _ticket || cell?.row?.original;
  const fieldName = params?.field?.name
    ? params?.field?.name
    : props?.cell?.value?.name
    ? props?.cell?.value?.name
    : '';
  const clientIds = ticket?.client?.accountId
    ? [ticket?.client?.accountId]
    : null;
  const siteIds = ticket?.site?.id ? [ticket.site.id] : null;
  const currentProduct = useProduct();
  const isFieldDependant = isDependantField(field.name);
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = (
    <div className="ml8 fx center" onClick={() => togglePopoverActive()}>
      <SVGIcon name="Edit" />
    </div>
  );

  const updateSelectedProperties = (changedProperties) => {
    const newProperties = {
      ...updatedProperties,
      ...changedProperties
    };
    setUpdatedProperties(newProperties);
    updateFieldState(newProperties);
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    let updatedProperty = {};
    if (f.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      if (val) {
        switch (f.name) {
          case 'techGroup':
            serialisedValue = { groupId: val.groupId, name: val.name };
            break;
          case 'technician':
            serialisedValue = {
              userId: val.userId,
              firstName: val.firstName,
              lastName: val.lastName
            };
            break;
          case 'client':
            serialisedValue = { accountId: val.accountId, name: val.name };
            break;
          case 'requester':
            serialisedValue = {
              userId: val.userId,
              firstName: val.firstName,
              lastName: val.lastName
            };
            break;
          default:
            serialisedValue = val.name;
        }
      }

      updatedProperty = { [f.name]: serialisedValue };
      if (parentField.name === f.name) {
        updatedProperty = {
          ...updatedProperty,
          [dependantField.name]: null
        };
      }
      updateSelectedProperties(updatedProperty);
    }
  };

  const getVariables = (type) => {
    let variables = {
      clientIds: {
        value: clientIds,
        type: '[ID!]'
      }
    };
    switch (type) {
      case 'getAllowedTechnicianGroups':
        return {
          input: { type: 'GetAllowedTechnicianGroupsInput!' }
        };
      case 'techGroupUsers':
        return {
          input: {
            type: 'GetTechnicianListInput!'
          }
        };
      default:
        return variables;
    }
  };

  const getGroupFields = () => {
    return [
      'groupId',
      'name',
      {
        userList: ['userId', 'email', 'firstName', 'lastName']
      }
    ];
  };
  const getClientVariables = () => {
    let variables = {
      listInfo: {
        type: 'ListInfoInput!'
      }
    };
    return variables;
  };

  const getRequesterVariables = () => {
    let variables = {
      accountId: {
        type: 'ID!'
      }
    };
    return variables;
  };

  const getClientFields = () => {
    return [
      {
        clients: ['accountId', 'name']
      }
    ];
  };
  const getrequesterGroupFields = () => {
    return ['userId', 'firstName', 'lastName', 'email', 'name'];
  };

  const getTechnicianFields = () => {
    return [
      {
        userList: ['userId', 'email', 'firstName', 'lastName', 'name']
      }
    ];
  };

  const dynamicGroupQuery = () => {
    switch (allProps.field.name) {
      case 'client':
      case 'requester':
        let generatorClient = new Generator({
          operation: 'getClientList',
          variables: getClientVariables(),
          fields: getClientFields()
        });
        const queryStringClient = generatorClient.queryBuilder();

        return AccountClient.query({
          query: gql`
            ${queryStringClient.query}
          `,
          fetchPolicy: 'network-only',
          variables: {
            listInfo: {
              sort: [
                {
                  attribute: 'name',
                  order: 'ASC'
                }
              ]
            }
          }
        });
      default:
        let generator = new Generator({
          operation: 'getAllowedTechnicianGroups',
          variables: getVariables('getAllowedTechnicianGroups'),
          fields: getGroupFields()
        });
        const queryString = generator.queryBuilder();

        return AccountClient.query({
          query: gql`
            ${queryString.query}
          `,
          fetchPolicy: 'network-only',
          variables: getTechnicianVariables({
            clientIds,
            siteIds,
            currentProduct
          })
        });
    }
  };
  const dynamicTechnicianQuery = () => {
    switch (allProps.dependantField.name) {
      case 'requester':
        let requesterClientId = updatedProperties.hasOwnProperty('client')
          ? updatedProperties?.client?.accountId
          : ticket?.client?.accountId;
        let generatorClientRequester = new Generator({
          operation: 'getClientUsers',
          variables: getRequesterVariables(),
          fields: getrequesterGroupFields()
        });
        const queryStringClientRequester = generatorClientRequester.queryBuilder();

        return AccountClient.query({
          query: GET_CLIENT_USERS_LIST,
          fetchPolicy: 'network-only',
          variables: getClientUserAssociationListVariables({
            clientId: requesterClientId,
            siteId: ticket?.site?.id,
            departmentId: ticket?.department?.businessFunctionId,
            currentProduct
          })
        });

      default:
        let groupName = updatedProperties.hasOwnProperty('techGroup')
          ? updatedProperties?.techGroup?.name
          : ticket?.techGroup?.name;
        if (groupName) {
          return dynamicGroupQuery();
        } else {
          let generator = new Generator({
            operation: 'getTechnicianList',
            variables: getVariables('techGroupUsers'),
            fields: getTechnicianFields()
          });
          const queryString = generator.queryBuilder();

          return AccountClient.query({
            query: gql`
              ${queryString.query}
            `,
            variables: getTechnicianVariables({
              clientIds,
              siteIds,
              currentProduct,
              isListInfoRequired: true
            })
          });
        }
    }
  };

  const getDisplayString = (key, element) => {
    if (typeof key === 'object') {
      return `${element[key[0]]} ${element[key[1]]}`; //todo vignesh loop
    } else {
      return element[key];
    }
  };

  const generateGroupOptions = (field, data) => {
    let options = [];
    let allValues = [];
    let key = 'name';
    if (data) {
      switch (field.name) {
        case 'client':
          options = data ? data['getClientList'].clients : [];
          allValues = options.map((element) => ({
            ...element,
            name: getDisplayString(key, element),
            value: getDisplayString(key, element),
            label: getDisplayString(key, element)
          }));
          break;
        case 'requester':
          options = data
            ? data['getClientUserAssociationsList']?.associations
            : [];
          allValues = options.map((element) => {
            element = element.user;
            return {
              ...element,
              name: getDisplayString(key, element),
              value: getDisplayString(key, element),
              label: getDisplayString(key, element)
            };
          });
          break;
        case 'techGroup':
          options = data ? data['getAllowedTechnicianGroups'] : [];
          allValues = options.map((element) => ({
            ...element,
            name: getDisplayString(key, element),
            value: getDisplayString(key, element),
            label: getDisplayString(key, element)
          }));
          break;
        case 'technician':
          let groupName = updatedProperties.hasOwnProperty('techGroup')
            ? updatedProperties?.techGroup?.name
            : ticket?.techGroup?.name;
          if (groupName) {
            options = data
              ? data['getAllowedTechnicianGroups'].find(
                  (el) => el.name === groupName
                )?.userList || []
              : [];
            key = ['firstName', 'lastName'];
            allValues = options
              ? options.map((element) => ({
                  ...element,
                  name: getDisplayString(key, element),
                  value: getDisplayString(key, element),
                  label: getDisplayString(key, element)
                }))
              : [];
          } else {
            options = data ? data.getTechnicianList?.userList : [];
            key = ['firstName', 'lastName'];
            allValues = options.map((element) => ({
              ...element,
              name: getDisplayString(key, element),
              value: getDisplayString(key, element),
              label: getDisplayString(key, element)
            }));
          }
          break;
        default:
      }
    }

    return allValues;
  };

  const _field = cell
    ? cell?.row?.values?.[cell?.column?.id] || {}
    : ticket?.[accessor];
  const displayVal =
    _field?.firstName && _field?.lastName
      ? `${_field.firstName} ${_field.lastName}`
      : _field?.firstName
      ? _field.firstName
      : _field?.name
      ? _field.name
      : '';

  const openNewTab = (props) => {
    switch (props.openTabFor) {
      case 'client':
        ticketContext.openTab({
          module: 'CLIENT',
          data: {
            id: props.params.accountId,
            name: props.params.name,
            value: props.params.name
          }
        });
        break;
      default:
    }
  };
  /*If the ticket is created by system we are getting requister value NA.
We are handing that instead of NA we use show SYSTEM */
  const renderValue = () => {
    return displayVal
      ? displayVal
      : fieldName === 'requester' && ticket.source === 'Agent'
      ? 'System'
      : <DisabledTag>NA</DisabledTag> || '--';
  };
  const FieldInfo = (props) => {
    const { action, params, openTabFor, ticketSource } = props;
    return (
      <>
        <Value
          className="sops-no-bold"
          link={openTabFor === 'client'}
          onClick={() => openNewTab(props)}
        >
          {renderValue()}
        </Value>
      </>
    );
  };

  //TODO :: render value in a proper way for NA - vignesh

  const fieldValue = updatedProperties?.[field?.name] || ticket?.[field?.name];
  const defaultValue = fieldValue
    ? typeof fieldValue === 'object'
      ? {
          name: fieldValue.name,
          label: fieldValue.name,
          value: fieldValue.name
        }
      : { name: fieldValue, label: fieldValue, value: fieldValue }
    : '';

  const parentFieldValue = updatedProperties.hasOwnProperty(parentField?.name)
    ? updatedProperties[parentField?.name]
    : ticket?.[parentField?.name];
  const defaultParentValue = parentFieldValue
    ? {
        ...parentFieldValue,
        name: `${parentFieldValue.name}`,
        label: `${parentFieldValue.name}`,
        value: `${parentFieldValue.name}`
      }
    : '';
  const dependantFieldValue = updatedProperties?.hasOwnProperty(
    dependantField?.name
  )
    ? updatedProperties?.[dependantField?.name]
    : ticket?.[dependantField?.name];
  const concatFnameLname = (fieldValue) => {
    return fieldValue.firstName && fieldValue.lastName
      ? `${fieldValue.firstName} ${fieldValue.lastName}`
      : fieldValue.firstName;
  };
  const defaultDependantValue = dependantFieldValue
    ? {
        name: concatFnameLname(dependantFieldValue),
        label: concatFnameLname(dependantFieldValue),
        value: concatFnameLname(dependantFieldValue)
      }
    : '';

  const Tag = type === 'tag' ? StyledTag : WrapperTag;
  return mode === 'view' ? (
    <Wrap
      className={`${
        isEditable ? 'editable-cell' : 'cell'
      } flex center full-height inlineSelect`}
    >
      <Tag className="ellipsis self-center flex center" title={displayVal}>
        <FieldInfo
          params={ticket?.client}
          value={displayVal}
          openTabFor={fieldName}
          ticketSource={ticket?.source}
        />
      </Tag>
      {isEditable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell pl8 pr8">
      <AsyncPropSelector
        updateSelection={updateSelection}
        ticket={ticket}
        field={field}
        isDynamicQuery
        generateOptions={generateGroupOptions}
        dynamicQuery={
          isFieldDependant
            ? dynamicTechnicianQuery
            : clientIds || siteIds
            ? dynamicGroupQuery
            : null
        }
        defaultValue={
          isFieldDependant ? defaultDependantValue : defaultParentValue
        }
        isClearable={isClearable}
        hideTitle
        defaultMenuIsOpen
      />
    </Wrap>
  );
}

export default InlineDependantSelect;

export { Wrap };
